"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.set");

var filterL = require('./filterL.js');

var mapL = require('./mapL.js');

var uniqueL = require('./uniqueL.js');

var curry2 = require("../Strict/curry2.js");

var go1 = require('../Strict/go1.js');

var go = require('../Strict/go.js');

module.exports = curry2(function intersectionByL(f, iter2, iter1) {
  let set = null;
  return uniqueL(filterL(a => go1(set || go1(mapL(f, iter2), l => set = new Set(l)), set => go(a, f, b => set.has(b))), iter1));
});